import DossierContactTarget from '../models/DossierContactTarget';
import { Nullish, present } from '../utils/typescript';

export function formatDossierContactTarget(target: Nullish<DossierContactTarget>): object | null {
  if (!target?.contact.customer) return null;
  return {
    dossierContactId: target.contact.id,
    identifier: target.target,
    customerName: target.contact.customer.fullName,
    languageCode: target.contact.customer.language,
  };
}

export function formatDossierContactTargets(targets: Array<DossierContactTarget>): Array<object> {
  return targets.map(ct => present(formatDossierContactTarget(ct)));
}